const sensorTypes = {
  pm2_5: 'PM 2.5',
  pm1_0: 'PM 1.0',
  pm10: 'PM 10',
  temperature: 'Temperature',
  humidity: 'Humidity',
};

export default sensorTypes;
